import HeatmapBackground from './background';
import HeatmapLegend from './legend';
var ComponentsInfo = {
    background: { Ctr: HeatmapBackground },
    legend: { Ctr: HeatmapLegend, padding: 'outer' },
};
export function getPlotComponents(plot, type, cfg) {
    if (plot.options[type] && plot.options[type].visible) {
        var componentInfo = ComponentsInfo[type];
        var component = new componentInfo.Ctr(cfg);
        if (componentInfo.padding) {
            plot.paddingController.registerPadding(component, componentInfo.padding);
        }
        return component;
    }
}
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g2plot@1.1.24@@antv/g2plot/esm/plots/density-heatmap/components/index.js
// module id = null
// module chunks = 